import React from "react";
import HomeSlider from "../Components/HomeSlider";
import Homebanner1 from "../Components/Homebanner1";
import Homebanner2 from "../Components/Homebanner2";
//import Tastyfishproducts from "../Components/Tastyfishproducts";
//import Shopmenu from "../Components/Shopmenu";
import Todaysdeal from "../Components/Todaysdeal";
import Newarrivals from "../Components/Newarrivals";
import BestSeller from "../Components/BestSeller";
import Recommendforyou from "../Components/Recommendforyou";
//import Demoslider from "../Components/Demoslider";

class Home extends React.Component {
    
    componentDidMount(){
        //AuthService.clearStorage()
      }
      
    render() {
         return <div> 
                 {/*<Shopmenu />*/}
                 {/* <Demoslider/> */}
                 <HomeSlider />
                 <Newarrivals />
                 <Homebanner1 />
                 <Todaysdeal/>
                 <Recommendforyou/>
                 <BestSeller />
                 <Homebanner2 />
                </div>
            

    }
}
export default Home;
